module.exports = __webpack_public_path__ + "media/_udalo_sie.4815981c.mp3";